import { format, parse } from "../../../date-fns/index.js";
import { todayBrowserDate } from "./constants.js";
const parseDateStringCache = /* @__PURE__ */ new Map();
function parseDate(dateAsString, dateFnsOptions) {
  const cacheEntry = parseDateStringCache.get(dateAsString);
  if (cacheEntry) return cacheEntry;
  if (dateAsString.length !== 8) throw new Error("Unsupported date format");
  return parse(`${dateAsString}T00:00`, `yyyyMMdd'T'HH:mm`, todayBrowserDate, dateFnsOptions);
}
function formatDate(date, dateFnsOptions) {
  return format(date, "yyyyMMdd", dateFnsOptions);
}
function calcMonthSize(config) {
  const { allowAutoMonthHeight, layout, hideDaysOfWeek } = config;
  const heightMult = hideDaysOfWeek ? 6 : 7;
  const { dayGapX, dayGapY, daySize } = layout;
  const totalDayGapX = dayGapX * 6;
  const totalDayWidths = daySize * 7;
  const totalDayGapY = dayGapY * 6;
  const totalDayHeights = daySize * heightMult;
  return {
    width: totalDayGapX + totalDayWidths,
    height: allowAutoMonthHeight ? "auto" : totalDayGapY + totalDayHeights
  };
}
function calcCalendarWidth(config) {
  const { layout, monthsCount } = config;
  const { width } = calcMonthSize(config);
  return width * monthsCount + (monthsCount > 1 ? layout.monthGap : 0);
}
export {
  calcCalendarWidth,
  calcMonthSize,
  formatDate,
  parseDate
};
//# sourceMappingURL=utils.js.map
